module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"jumbotron text-center\">\r\n    <h1>\r\n      <span translate>ABOUT.APP_NAME</span>\r\n    </h1>\r\n    <p>\r\n      <i class=\"fa fa-bookmark-o\"></i>\r\n      <span translate [translateParams]=\"{value: version}\">ABOUT.VERSION</span>\r\n    </p>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/app/about/about.component.html
// module id = ../../../../../src/app/about/about.component.html
// module chunks = main